export const enum DescriptionOptionEnum {
  HIDE_ON_MOBILE = 'Hide on Mobile',
  HIDE_ON_DESKTOP = 'Hide on Desktop'
}

export type DescriptionOption = `${DescriptionOptionEnum}`;
